import { render, staticRenderFns } from "./products_home.vue?vue&type=template&id=697e5489&scoped=true"
import script from "./products_home.vue?vue&type=script&lang=js"
export * from "./products_home.vue?vue&type=script&lang=js"
import style0 from "./products_home.vue?vue&type=style&index=0&id=697e5489&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697e5489",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('697e5489')) {
      api.createRecord('697e5489', component.options)
    } else {
      api.reload('697e5489', component.options)
    }
    module.hot.accept("./products_home.vue?vue&type=template&id=697e5489&scoped=true", function () {
      api.rerender('697e5489', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/products_home.vue"
export default component.exports